import apiClient from "services/ApiClient";
import { generatePath, redirect } from "react-router";
import { API_ROUTES, UNAUTHENTICATED_ROUTES } from "definitions/constants/routeConstants";
import useCaminoStore from "./useCaminoStore";

export default function useLogout() {
  const clearStore = useCaminoStore((state) => state.clearStore);

  const logout = () => {
    apiClient.delete(generatePath(API_ROUTES.sessions.show, { id: "current" })).then(() => {
      clearStore();
      redirect(UNAUTHENTICATED_ROUTES.login);
      // Reload to refresh the CSRF token
      window.location.reload();
    });
  };
  return logout;
}
